// extracted by mini-css-extract-plugin
module.exports = {"SFilmFacts":"FilmFacts_SFilmFacts__alWrY"};